import useSWR from 'swr';

import { publicConfig } from '@public-config';

import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { ApiService } from 'services/ApiService';

const useCompanyCount = (company: CompanyProfile) => {
    const swr = useSWR<{
        products: { total: number; published: number };
        referenceDesigns: { total: number; published: number };
        caseStudies: { total: number };
    }>(
        CompanyHelpers.swr.count(company.id),
        () => ApiService.get(`${publicConfig.urls.api}/manufacturers/${company.id}/count`),
        { revalidateOnMount: true },
    );

    return {
        products: swr.data?.products,
        referenceDesigns: swr.data?.referenceDesigns,
        caseStudies: swr.data?.caseStudies,
        ...swr,
    };
};

export { useCompanyCount };
